export default {
  "bank-logo": "_bank-logo_r3yewe",
  "bank-container": "_bank-container_r3yewe"
};
